/** Page-level head metadata contributed by a `load` function and resolved
 *  into concrete `<head>` tags by the root layout. See
 *  `docs/architecture/page-metadata.md` for the full pattern. */
export type PageHead = {
  /** Leaf-most title segment (e.g. "Big Bend 2026" or "Gear"). */
  title?: string;
  /** Optional accumulated crumbs for nested entity titles. When present,
   *  joined with the separator instead of using `title`. */
  titleSegments?: string[];
  /** Sentence-form description, ~50–160 chars. Defaults to the site default. */
  description?: string;
  /** Overrides `url.pathname` for the canonical URL. Use when query params
   *  are part of canonical identity, or when the canonical lives elsewhere. */
  canonicalPath?: string;
  /** Emit `<meta name="robots" content="noindex,nofollow">`. Use for share
   *  links, preview pages, and any route that shouldn't appear in search. */
  noIndex?: boolean;
  og?: {
    /** Absolute URL (or root-relative path) to a 1200×630 PNG/JPG. */
    image?: string;
    type?: 'website' | 'article';
  };
  /** Schema.org JSON-LD blobs to emit as `<script type="application/ld+json">`
   *  inside the root layout's `<svelte:head>`. Each entry is one structured-
   *  data record; emit multiple for compound pages (e.g. Organization +
   *  WebSite on the marketing landing). Use https://schema.org/ vocabulary
   *  and validate with Google's Rich Results Test before shipping. */
  jsonLd?: Record<string, unknown>[];
};

export const siteName = 'StuffPack';
export const titleSeparator = ' | ';
export const defaultDescription = 'Prepare for your next adventure.';
export const defaultOgImage = '/og/default.png';
